import Database from "@tauri-apps/plugin-sql";

// Verifica se a aplicação está rodando dentro do Tauri
export const isTauri = (): boolean => {
  return typeof window !== "undefined" && (window as any).__TAURI_INTERNALS__ !== undefined;
};

// Nome do banco de dados SQLite local
const DB_NAME = "sqlite:itacondo.db";

let dbInstance: Database | null = null;

// Mock database em memória para desenvolvimento no navegador
class MockDatabase {
  private tables: Record<string, any[]> = {
    system_settings: [],
    condominiums: [],
    units: [],
    profiles: [],
    visitors: []
  };

  async execute(query: string, values: any[] = []): Promise<{ rowsAffected: number }> {
    console.log("[MockDB Execute]", query, values);
    return { rowsAffected: 1 };
  }

  async select<T>(query: string, values: any[] = []): Promise<T[]> {
    console.log("[MockDB Select]", query, values);
    // Simula queries básicas retornando listas vazias ou mocks
    if (query.toLowerCase().includes("select * from system_settings")) {
      return this.tables.system_settings as T[];
    }
    if (query.toLowerCase().includes("select * from condominiums")) {
      return this.tables.condominiums as T[];
    }
    if (query.toLowerCase().includes("select * from units")) {
      return this.tables.units as T[];
    }
    if (query.toLowerCase().includes("select * from profiles")) {
      return this.tables.profiles as T[];
    }
    return [] as T[];
  }
}

const mockDb = new MockDatabase();

// Retorna a conexão com o banco de dados
export const getDb = async () => {
  if (!isTauri()) {
    return mockDb;
  }

  if (!dbInstance) {
    dbInstance = await Database.load(DB_NAME);
  }
  return dbInstance;
};

// Executa comandos (INSERT, UPDATE, DELETE, CREATE TABLE)
export const dbExecute = async (query: string, values: any[] = []): Promise<any> => {
  const db = await getDb();
  return await db.execute(query, values);
};

// Executa consultas (SELECT)
export const dbSelect = async <T>(query: string, values: any[] = []): Promise<T[]> => {
  const db = await getDb();
  return (await db.select<T>(query, values)) as T[];
};

// Converte caminhos locais de arquivo para URLs do protocolo asset:// no Tauri
export const resolvePhotoUrl = (url: string | null): string => {
  if (!url) return "";
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("data:") ||
    url.startsWith("blob:")
  ) {
    return url;
  }

  if (isTauri()) {
    try {
      const { convertFileSrc } = require("@tauri-apps/api/core");
      return convertFileSrc(url);
    } catch (e) {
      // Fallback em caso de falha no require (ESM runtime)
      try {
        const globalTauri = (window as any).__TAURI__;
        if (globalTauri && globalTauri.core) {
          return globalTauri.core.convertFileSrc(url);
        }
      } catch (err) {
        console.error("Erro ao converter URL de mídia local:", err);
      }
    }
  }
  return url;
};

